import { ScheduleGridHeaderCellProps } from 'components/ScheduleGrid/ScheduleGrid.Types';

const ProductionScheduleLeftHeaderCell = (
  props: ScheduleGridHeaderCellProps
) => {
  // console.log('props', props);
  return (
    <div
      style={{
        border: '1px solid #eee',
        ...props.style,
        ...props.styles,
      }}
    >
      <b>Date</b>
    </div>
  );
};

export default ProductionScheduleLeftHeaderCell;
